import { DatosUsuarioLocalStorang, DatoTokenusuario, Host, DatosUsuariocliente, Whatsappnumero } from "./constantes"
import jwtDecode from "jwt-decode";
import axios from "axios";

const CEDULA_REQUEST_TIMEOUT_MS = 8000

function normalizarRespuestaCedula(baseCedula, payload = {}) {
    const cedula = payload.cedula || payload.nui || payload.ruc || String(baseCedula || "")
    const name = payload.name || payload.nombre || ""
    const fechaNacimiento = payload.fecha_nacimiento || payload.fechaNacimiento || null
    const edad = payload.edad ?? ""
    const direccion = payload.direccion || payload.lugarNacimiento || null
    const discapacidadTexto = String(payload.discapacidad || payload.condicionCedulado || "")
    const discapacidad = discapacidadTexto.toUpperCase().includes("DISCAPA") || String(payload.discapacidad || "").toLowerCase() === "si"
        ? "Si"
        : "No"

    return {
        "id": 0,
        "cedula": cedula,
        "direccion": direccion,
        "discapacidad": discapacidad,
        "edad": edad,
        "email": payload.email ?? "null",
        "genero": payload.genero || payload.sexo || "Masculino",
        "name": name,
        "sexo": payload.sexo || payload.genero || "Masculino",
        "telefono": payload.telefono ?? payload.telefono2 ?? null,
        "estado_civil": payload.estado_civil ?? null,
        "fecha_nacimiento": fechaNacimiento
    }
}

// Antes esta funcion llamaba directo al proveedor SRI con usuario/token embebidos aca
// (visibles para cualquiera que abra el bundle JS). Ahora pasa por nuestro backend, que
// guarda esas credenciales en el servidor.
async function getCedulaDesdeSRI(params) {
    const { data } = await axios.get(`https://api.t-ickets.com/ms_login/api/v1/consultar_cedula_sri/${params}`, {
        timeout: CEDULA_REQUEST_TIMEOUT_MS,
        headers: {
            'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
        }
    })

    if (!data || data.success !== true || !data.data) {
        throw new Error("Respuesta SRI sin datos")
    }

    return normalizarRespuestaCedula(params, {
        ...data.data,
        cedula: params
    })
}

async function getCedulaDesdeManta(params) {
    const { data } = await axios.get(`https://api.t-ickets.com/ms_login/api/v1/consultar_cedula_turnos/${params}`, {
        timeout: CEDULA_REQUEST_TIMEOUT_MS,
        headers: {
            'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
        }
    })

    if (!data || data.success !== true || !data.data) {
        throw new Error("Respuesta Manta sin datos")
    }

    return normalizarRespuestaCedula(params, {
        ...data.data,
        cedula: params
    })
}
export const DatosUsuariosLocalStorag = (data) => {
    sessionStorage.setItem(DatosUsuarioLocalStorang, JSON.stringify(data))
    return true
}

function clearSessionEventCaches() {
    sessionStorage.removeItem("PreciosLocalidad")
    sessionStorage.removeItem("Suscritorid")
    sessionStorage.removeItem("localidadesnombres")
}

export const getDatosUsuariosLocalStorag = () => {
    let data = JSON.parse(sessionStorage.getItem(DatosUsuarioLocalStorang))
    const randon = sessionStorage.getItem("random") || ""
    if (data !== null) {
        return data
    } else {
        return { id: 0, cedula: "" + randon, discapacidad: "No" }
    }
}
export const UpdateDatosUsuariosLocalStorag = (paramas) => {
    let data = JSON.parse(sessionStorage.getItem(DatosUsuarioLocalStorang))
    let datos = {
        ...data,
        ...paramas
    }
    sessionStorage.setItem(DatosUsuarioLocalStorang, JSON.stringify(datos))
    const randon = sessionStorage.getItem("random") || ""
    if (data !== null) {
        return JSON.parse(sessionStorage.getItem(DatosUsuarioLocalStorang))
    } else {
        return { id: 0, cedula: "" + randon, discapacidad: "No" }
    }
}
export function getCliente() {
    let data = JSON.parse(sessionStorage.getItem(DatosUsuariocliente))
    if (data !== null) {
        return data
    } else {
        return null
    }
}
// export async function getCedula(cedula) {
//     try {
//         const { data } = await axios.get("https://api.t-ickets.com/ms_login/cedula/" + cedula)

//         const { success } = data
//         if (success) {
//             return data.data;
//         } else {
//             return false
//         }
//     } catch (error) {
//         return false;
//     }
// }

export async function getCedula(params) {
    try {
        return await getCedulaDesdeSRI(params)
    } catch (error) {
        try {
            return await getCedulaDesdeManta(params)
        } catch (fallbackError) {
            return false
        }
    }
}

//estas funciones las Agrege en caso de uso dee usuario loggeado
export function setDatosUser(data) {
    try {
        clearSessionEventCaches()
        const datas = {
            timestamp: Date.now() // Guarda el tiempo actual en milisegundos
        };
        sessionStorage.setItem(DatoTokenusuario, data)
        //sessionStorage.setItem("Time", JSON.stringify(datas))
        return true
    } catch (error) {
        // return {'estado':false,'error':error}        
    }
}
export function checkLocalStorageExpiration() {
    const data = localStorage.getItem("Time");

    if (data) {
        const parsedData = JSON.parse(data);
        const now = Date.now();
        const twelveHours = 12 * 60 * 60 * 1000; // 12 horas en milisegundos

        if (!parsedData.timestamp) {
            //window.location.reload()
            sessionStorage.removeItem(DatoTokenusuario);
            sessionStorage.removeItem("Time");
            return true
        }
        if (now - parsedData.timestamp > twelveHours) {
            // window.location.reload()
            sessionStorage.removeItem(DatoTokenusuario); // Borra el dato si ha pasado el tiempo


            return true
        }
        sessionStorage.removeItem(DatoTokenusuario); // Borra el dato si ha pasado el tiempo
        sessionStorage.removeItem("Time");
        return false
    }
}
export function getUsuario() {
    try {
        const data = sessionStorage.getItem(DatoTokenusuario)

        return data;

    } catch (error) {
        return error
    }
}
export function removeDatosUsuario() {
    try {
        clearSessionEventCaches()
        sessionStorage.removeItem(DatoTokenusuario)
        sessionStorage.removeItem("Time");
    } catch (error) {

    }
}
export function clienteInfo() {

    let user = getUsuario();
    if (user) {
        return jwtDecode(user)
    } else {
        return null
    }
}

// Chequeo proactivo: jwtDecode NO valida el token, solo lee el payload --
// un JWT vencido se sigue "decodificando" normal, con un campo `exp`
// (segundos unix) que ya quedo en el pasado. Antes nada comparaba eso
// contra la hora actual, asi que layouts/Admin.js dejaba pasar sesiones
// vencidas como si fueran validas: el usuario veia el panel entero
// renderizado, pero cada llamada al backend fallaba o volvia con datos
// vacios/incompletos SIN avisar nada. Login (expiresIn: '2h' en
// LoginAdmin.controller.js) siempre manda `exp`, asi que esto es confiable.
export function estaSesionExpirada() {
    const user = clienteInfo()
    if (!user || !user.exp) return false
    return (Date.now() / 1000) >= user.exp
}

/* Pide un JWT nuevo con mas tiempo (ver ExtenderSesion en
   LoginAdmin.controller.js) a partir del token actual, AUNQUE ya haya
   vencido -- el backend valida la firma con ignoreExpiration:true, asi que
   sigue sin poder fabricarse/alterarse, solo se deja de exigir que este
   vigente (con un tope de 24h desde que vencio). Si sale bien, YA deja el
   token nuevo guardado (mismo lugar que usa el login) -- quien llama esto
   no tiene que hacer nada mas que limpiar la bandera de sesion expirada. */
export async function extenderSesion(minutos) {
    try {
        const tokenActual = getUsuario()
        if (!tokenActual) return { success: false, message: "No hay sesion para extender" }
        const { data } = await axios.post(
            "https://api.t-ickets.com/ms_login/api/v1/extender_sesion",
            { minutos },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ==',
                    'Authorization': `Bearer ${tokenActual}`,
                }
            }
        )
        if (data?.success && data?.token) {
            // OJO: a proposito NO se usa setDatosUser aca -- esa funcion
            // llama clearSessionEventCaches() (borra PreciosLocalidad,
            // Suscritorid, localidadesnombres), pensado para un login nuevo.
            // Extender la sesion es lo opuesto: el objetivo es que la pagina
            // en la que el usuario esta trabajando (ej. vendiendo un boleto)
            // siga exactamente igual, asi que solo se pisa el token.
            sessionStorage.setItem(DatoTokenusuario, data.token)
        }
        return data
    } catch (error) {
        return {
            success: false,
            message: error?.response?.data?.message || "No se pudo extender la sesión",
        }
    }
}